<script>
  // Renders a truthy/falsy value as a check/x icon. Column may set
  // `trueLabel`/`falseLabel` for an aria-label + tooltip.
  import Icon from '../../ui/icon.svelte'
  let { value, column = {} } = $props()
  const on = $derived(!!value)
  const label = $derived(on ? (column.trueLabel ?? 'Yes') : (column.falseLabel ?? 'No'))
</script>

<span title={label} aria-label={label}>
  {#if on}
    <Icon name="success" class="text-success inline" />
  {:else}
    <Icon name="close" class="text-base-content/30 inline" />
  {/if}
</span>
